@use '@lib/assets/styles/main.scss' as *;
.column {
  @extend .col-xs-6;
}

.titleColumn {
  padding-bottom: 8px;
}

.formTypeSwitcher {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  margin-top: -16px;
}

.fieldTitle {
  margin-bottom: 0;
}
